import { createSelector } from 'redux-bundler';

// spread route params and query string params on each other to combine them...
// priority given to route params
export const selectUrlParams = createSelector(
  'selectRouteParams',
  'selectQueryObject',
  (routeParams, queryParams) => ({
    ...queryParams,
    ...routeParams,
  }),
);
